import { isDefined } from '@utils/isDefined';
import { Optional } from 'chaika-common-types';
import { DateHelper, DateType } from '@utils/DateHelper';

export const FilterListHelpers = {
    filterFieldValue<T>(value: T, filterValue: Optional<any>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? value[fieldName] === filterValue : true;
    },

    filterExecuteFieldValue<T>(value: T, executeValue: Optional<any>, fieldName: keyof T): boolean {
        return isDefined(executeValue) ? value[fieldName] !== executeValue : true;
    },

    filterFieldValueByArray<T>(value: T, filterValue: Optional<any[]>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? filterValue.includes(value[fieldName]) : true;
    },

    filterFieldValueByExclusiveArray<T>(value: T, filterValue: Optional<any[]>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? !filterValue.includes(value[fieldName]) : true;
    },

    filterArrayFieldValue<T>(value: T, filterValue: Optional<any>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? (value[fieldName] as any[]).includes(filterValue) : true;
    },

    filterArrayFieldValueByArray<T>(value: T, filterValue: Optional<any[]>, fieldName: keyof T): boolean {
        const filterValuesSet = isDefined(filterValue) ? new Set(filterValue) : undefined;
        return isDefined(filterValuesSet) ? (value[fieldName] as any[]).some(val => filterValuesSet.has(val)) : true;
    },

    filterFieldValueIncludesString<T>(value: T, filterValue: Optional<string>, fieldName: keyof T): boolean {
        return isDefined(filterValue) && filterValue.length > 0
            ? ((value[fieldName] as string) || '').toLocaleLowerCase().includes(filterValue.toLowerCase())
            : true;
    },

    filterFieldValueBySameDay<T>(value: T, filterValue: Optional<DateType>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? DateHelper.isSameDay(filterValue, value[fieldName] as DateType) : true;
    },

    filterFilterValueSameOrAfterFieldValue<T>(value: T, filterValue: Optional<DateType>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? DateHelper.isSameOrAfter(filterValue, value[fieldName] as DateType) : true;
    },

    filterFilterValueBeforeFieldValue<T>(value: T, filterValue: Optional<DateType>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? DateHelper.isBefore(filterValue, value[fieldName] as DateType) : true;
    },

    filterFieldValueBySameOrAfterDate<T>(value: T, filterValue: Optional<DateType>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? DateHelper.isSameOrAfter(value[fieldName] as DateType, filterValue) : true;
    },

    filterFieldValueBySameOrBeforeDate<T>(value: T, filterValue: Optional<DateType>, fieldName: keyof T): boolean {
        return isDefined(filterValue) ? DateHelper.isSameOrBefore(value[fieldName] as DateType, filterValue) : true;
    },
};
